<template>
    <div>
        <div v-if="$route.path.indexOf('_editor') === -1">
            <el-row>
              <el-col :md="10" :lg="10">
                <el-input :rows="1" placeholder="输入手机号搜索" v-model="params.inca_ids" clearable size="mini">
                  <el-button slot="append" icon="el-icon-search" @click="goodsSearch"></el-button>
                </el-input>
              </el-col>
            </el-row>
            <el-table :data="list" style="width: 100%" border v-loading="loading" element-loading-text="数据加载中">
                <el-table-column type="expand">
                  <template slot-scope="props">
                    <el-table :data="props.row.children" style="width: 100%" element-loading-text="数据加载中">
                      <el-table-column prop="api_name" label="接口名称" width="160"></el-table-column>
                      <el-table-column prop="api_path" label="接口地址" width="320"></el-table-column>
                      <el-table-column prop="stock" label="当日接口可用配额" width="145"></el-table-column>
                      <el-table-column prop="used" label="当日已经消耗额度" width="145"></el-table-column>
                    </el-table>
                  </template>
                </el-table-column>
                <el-table-column prop="service_name" label="服务提供商" width="120"></el-table-column>
                <el-table-column prop="key" label="服务商授权KEY"></el-table-column>
                <el-table-column prop="username" label="账号归属人姓名" width="135"></el-table-column>                <el-table-column prop="mobile" label="账号归属人手机号" width="135"></el-table-column>
                <el-table-column label="状态" width="90">
                  <template slot-scope="scope">
                    <el-switch v-model="scope.row.is_disabled" active-value="0" inactive-value="1" active-color="#13ce66"  inactive-color="#ff4949" @change="switchDisabled(scope.$index, scope.row)"></el-switch>
                  </template>
                </el-table-column>
                <el-table-column label="操作">
                  <!-- <template slot-scope="scope">
                    <el-button type="text" size="small" @click="getKeysDetail(scope.row)">编辑</el-button>
                  </template> -->
                </el-table-column>
            </el-table>
            <div class="content-center content-top-padded">
              <el-pagination
                  background
                  layout="total, sizes, prev, pager, next"
                  @current-change="handleCurrentChange"
                  @size-change="handleSizeChange"
                  :current-page.sync="params.page"
                  :page-sizes="[20,50,100,200]"
                  :total="total_count"
                  :page-size="params.pageSize">
              </el-pagination>
            </div>
            <el-dialog title="编辑" :visible.sync="editdialogVisible" width="50%">
              <el-form ref="form" :model="form" label-width="130px">
                <el-form-item label="账号归属人姓名">
                  <el-col :span="14">
                    <el-input v-model="form.username" placeholder="账号归属人姓名"></el-input>
                  </el-col>
                </el-form-item>
                <el-form-item label="账号归属人手机号">
                  <el-col :span="14">
                    <el-input v-model="form.mobile"></el-input>
                  </el-col>
                  <!-- <span style="color: #f00;">一次只能设置一个商品的区域划线价</span> -->
                </el-form-item>
                <el-form-item label="服务商授权KEY">
                  <el-col :span="14">
                    <el-input disabled v-model="form.key"></el-input>
                  </el-col>
                  <!-- <span style="color: #f00;">（单位：元）设置为 0 时则取消该商品的区域划线价</span> -->
                </el-form-item>
                <div class="section-footer with-border content-center">
                  <el-button size="large" @click="cancelSubmit">取消</el-button>
                  <el-button type="primary" @click="editLbsKeys" :loading="submitLoading">{{submitLoading ? '提交中' :
                    '保存'}}
                  </el-button>
                </div>
              </el-form>
            </el-dialog>
        </div>
        <router-view></router-view>
    </div>
</template>
<script>
import {getLbsKeys, addLbsKeys, editLbsKeys, delLbsKeys} from '@/api/wechat'
export default {
    data() {
      return {
        loading: false,
        params: {
          page: 1,
          pageSize: 20,
        },
        form: {
          username: '',
          mobile: '',
          type: 'tx',
          key: '',
          disabled: 0,
        },
        total_count: 0,
        list: [],
        editdialogVisible: false,
      }
    },
    methods: {
      getLbsKeyList() {
        this.loading = true
        console.log(this.params)
        getLbsKeys(this.params).then(res => {
          this.loading = false
          this.list = res.data.data.list
          this.total_count = res.data.data.total_count
        })
      },
      switchDisabled(idx, row) {
        console.log(idx, row)
        var params = {
          disabled: row.is_disabled,
        }
        editLbsKeys(params, row.sid).then(res => {
          if (res.data.data.status == true) {
            this.$message({
              type: 'success',
              message: '状态修改成功'
            })
          } else {
            this.$message({
              type: 'error',
              message: '状态修改失败'
            })
          }
          this.getLbsKeyList()
        })
      },
      getKeysDetail(row) {
        console.log(row)
        this.editdialogVisible = true;
      },
      editLbsKeys(idx, row) {
        console.log(idx, row)
        var params = {
          disabled: row.is_disabled,
        }
        editLbsKeys(params, row.sid).then(res => {
          if (res.data.data.status == true) {
            this.$message({
              type: 'success',
              message: '状态修改成功'
            })
          } else {
            this.$message({
              type: 'error',
              message: '状态修改失败'
            })
          }
          this.getLbsKeyList()
        })
      },
      cancelSubmit() {
        this.editdialogVisible = false
      },
      // goodsSearch() {
      //   this.params.page = 1
      //   this.getLbsKeyList()
      // },
      handleSizeChange(pageSize) {
        this.params.page = 1
        this.params.pageSize = pageSize
        this.getLbsKeyList()
      },
      handleCurrentChange(page_num) {
        this.params.page = page_num
        this.getLbsKeyList()
      },
      acitonIsDiff() {
        this.params.page = 1
        this.getLbsKeyList()
      },
    },
    mounted() {
      this.getLbsKeyList()
    }
  }
</script>




// WEBPACK FOOTER //
// list.vue?aae73392